<nz-layout class="app-layout">
  <nz-drawer (nzOnClose)="showUserPanel = false" [nzClosable]="false" [nzVisible]="showUserPanel"
             [nzWidth]="300" nzPlacement="right" nzTitle="User Profile">
    <ng-container *nzDrawerContent>
      <app-user-panel [user]="user$()"></app-user-panel>
    </ng-container>
  </nz-drawer>

  <nz-sider class="menu-sidebar"
            nzCollapsible
            [nzBreakpoint]="'xl'"
            [nzCollapsedWidth]="xs$() ? 0 : 70"
            nzWidth="240px">
    <div class="sidebar-logo">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <div>
          <img alt="logo" ngSrc="assets/brand-logo.jpg" height="90" width="140">
          <h1>SRiMS</h1>
        </div>
        <button [routerLink]="['forward']" [queryParams]="{ module: 'welcome' }"
                style="margin-right: 15px;" nz-button>
          <nz-icon style="font-size: 18px;" nzType="swap" nzTheme="outline"/>
        </button>
      </div>
    </div>
    <ul nz-menu nzMode="inline" nzTheme="dark">
      @for (m of user$().menus; track m.id) {
        <li nz-submenu [nzIcon]="m.icon" [nzTitle]="m.text"
            [(nzOpen)]="openMap[m.id]"
            (nzOpenChange)="openHandler(m.id)">
          <ul>
            @for (s of m.menu_items; track s.id) {
              @if (s.seq < 1000) {
                <li nz-menu-item nzMatchRouter>
                  <a [routerLink]="s.urlSegment" [queryParams]="s.queryParams">{{ s.text }}</a>
                </li>
              }
            }
          </ul>
        </li>
      }
    </ul>
  </nz-sider>

  <nz-layout>

    <nz-header>
      <div class="app-header">
        <div class="header-title">
          @if (!xs$()) {
            {{ title$() }}
          }
        </div>
        <div class="header-user">
          @if (!xs$()) {
            <nz-avatar (click)="showUserPanel=true" nzIcon="user"></nz-avatar>
            <span class="user-name">{{ user$().name }}</span>
          }
          <button (click)="logout()" nz-button nzShape="round" nzType="primary">Sign Out</button>
        </div>
      </div>
    </nz-header>

    <nz-content>
      <router-outlet></router-outlet>
    </nz-content>
  </nz-layout>
</nz-layout>

